import url from 'url';
import get from 'lodash/get';

import vars from '../../vars';
import isServer from '../isServer';

import {
  homeCampaign,
  profileCampaign,
  channel,
} from '../../constants/analytics/branch';
import { TEXT_ME_THE_APP_ENABLED } from '../../constants/experiments/dialog';
import {
  LOGIN_PATH,
  SUBSCRIBE_PATH,
  AUTHORIZE_PATH,
  AUTHORIZE_CONFIRM_PATH,
  ACCOUNT_NEW_RESET_PATH,
} from '../../constants/paths';
import getDeepLinkPath from './getDeepLinkPath';

// exported for testing
export const blackListedBranchRoutes = [
  LOGIN_PATH,
  SUBSCRIBE_PATH,
  AUTHORIZE_PATH,
  AUTHORIZE_CONFIRM_PATH,
  ACCOUNT_NEW_RESET_PATH,
];

export function getLinkMeta({ guideId, serial, abTestIds, customCampaign }) {
  const defaultCampaign = guideId ? profileCampaign : homeCampaign;

  return {
    $deeplink_path: getDeepLinkPath(guideId),
    campaign: customCampaign || defaultCampaign,
    channel,
    user_id: serial,
    ab_test_id: abTestIds,
  };
}

export function getFallbackLink(linkMetaData) {
  return url.format({
    protocol: 'https',
    host: 'listen.tunein.com',
    pathname: `/a/${vars.get('BRANCH_KEY')}/`,
    query: linkMetaData,
  });
}

export function createBranchLink(options, setBranchUrl) {
  const linkMetaData = getLinkMeta(options);
  const fallbackLink = getFallbackLink(linkMetaData);

  window.branch.link(
    {
      data: linkMetaData,
    },
    (err, link) => {
      // If the request ever comes back and there is no link (this will most likey be if there's an
      // error of sorts with the branch API), let's use the fallback so we can still deeplink
      // regardless.
      if (link) {
        setBranchUrl(link);
      } else {
        setBranchUrl(fallbackLink);
      }
    },
  );
}

// options: { guideId, title, serial, abTestIds, customCampaign }
export function setBranchViewData(options) {
  window.branch.setBranchViewData({
    data: {
      ...getLinkMeta(options),
      referrer_unique_id: options.serial,
    },
  });
}

export function closeBranchJourney() {
  window.branch.closeJourney();
}

// this only reopens it if it was not closed by the user
export function reopenBranchJourney() {
  window.branch.track('pageview');
}

// listener event names: https://docs.branch.io/pages/web/integrate/#handle-listeners
export function addBranchListener(eventName, callback) {
  window.branch.addListener(eventName, callback);
}

export function isBranchInitialized() {
  return !isServer() && !!window.branch;
}

export function isBlacklistedBranchRoute(route) {
  return blackListedBranchRoutes.includes(route);
}

export function initBranch({ app, config }, route) {
  const isMobile = get(app, 'isMobile');
  const isTextMeTheAppEnabled = get(config, [
    'autoupdate',
    TEXT_ME_THE_APP_ENABLED,
  ]);

  if (isMobile || isTextMeTheAppEnabled) {
    // using `require()` here, as branch-sdk will attempt to modify the window object
    // eslint-disable-next-line global-require
    require('branch-sdk');

    const key = vars.get('BRANCH_KEY');
    const serial = get(app, 'tuneInUserSerial', '');
    const abTestIds = get(config, ['autoupdate', 'abtest.ids'], '');

    const options = {
      metadata: {
        user_id: serial,
        ab_test_id: abTestIds,
        referrer_unique_id: serial,
      },
      no_journeys: isBlacklistedBranchRoute(route),
    };

    window.branch.init(key, options);
    window.branch.setIdentity(serial);
  }
}
